import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Wrapper from "../components/wrapper/Wrapper";
import homeBanner from "../images/home_page_banner.jpg";  
import homeBannerMob from "../images/home_page_banner_mobile.jpg";    
import rightArrow from "../images/right_arrow.png";
import slideImg from "../images/ExpeditionsHome.jpg";
import BoxItem from "../components/BoxItem";
import { Carousel } from "react-responsive-carousel";
import ourStoryImage from "../images/our_story.png";
import boxItemIgm1 from "../images/box_item_1.png";
import boxItemIgm2 from "../images/box_item_2.png";
import boxItemIgm3 from "../images/box_item_3.png";
import CarouselSlider from "../components/Carousel";
import slideImg2 from "../images/ExperiencesHome.jpg";
import { getBlog } from "../servies/services";

const sliderImg = [
  {
    id: "01",
    slideUrl: slideImg,
    title: "Expeditions",
    altName: "slide 1",
    sliderLink: "/explore/expeditions",
    rightArrow: rightArrow,
    content: "Discover the true wilderness of the Himalayas on remote treks & expeditions."
  }
];

const sliderImg2 = [
  {
    id: "01",
    slideUrl: slideImg2,
    title: "Experiences",
    altName: "slide 1",
    sliderLink: "/explore/experiences",
    rightArrow: rightArrow,
    content: "Immerse in the essence of the Himalayas through its vibrant cultures, breathtaking landscapes, and the genuine warmth of its people."
  }
];

const HomePage = () => {
  const [mainData, setMainData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const blogData = await getBlog('blog');
      setMainData(blogData?.data.data);
    }
    getData();
  }, [])

  return (
    <>
      <Wrapper
        desktopImage={homeBanner}
        mobileImage= {homeBannerMob}
        firstTitle="TRAVEL DEEP INTO"
        bannerHeading="The <br /> Himalayas"
        bansubheading="First light Adventures"
        banpara="First Light Adventures takes you deep into the heart of the Himalayas, offering a seamless mix of raw adventure and thoughtful experiences. Whether it’s high-altitude expeditions or quiet mountain retreats, we’re redefining exploration in one of the world’s most breathtaking landscapes."
        topfootHead="Get in Touch!"
        topfootPara="Get in touch for any Himalayan travel insights—we’re here to help. Enjoy a free consultation call, whether you’re planning a trip or need advice on an itinerary. "
        bookCall="Book a Discovery Call"
      >
        <div className="container inner-container">

          <div className="slider2">
            <Carousel interval="5000"
              showArrows={false} showThumbs={false} showIndicators={false} >
              {sliderImg.map((image, i) =>
                <div key={image.i}>
                  <img src={image.slideUrl} alt={image.altName} />
                  <div className="legend"> <p> {image.title} </p>
                    <Link to={image.sliderLink} className="sliderlink"> Know More <span className="rightarrow"> </span>    </Link>
                    <p className="content"> {image.content} </p>
                  </div>
                </div>
              )}
            </Carousel>
          </div>
          <div className="slider2">
            <Carousel
              showArrows={false} showThumbs={false} showIndicators={false} >
              {sliderImg2.map((image, i) =>
                <div key={image.i}>
                  <img src={image.slideUrl} alt={image.altName} />
                  <div className="legend"> <p> {image.title} </p>
                    <Link to={image.sliderLink} className="sliderlink"> Know More <span className="rightarrow"> </span>  </Link>
                    <p className="content"> {image.content} </p>
                  </div>
                </div>
              )}
            </Carousel>
          </div>
          {/* <div className="explore_blog">
            <h2> Know More </h2>
            <h3> Get Ready to Explore with our Blog! </h3>
            <span className="hori_line"></span>
            <div className="row">
              {mainData?.slice(0, 3)?.map((dataItem) => {
                const { publish_date, title, description, slug } = dataItem;
                return (
                  <BoxItem
                    imgSrc={boxItemIgm1}
                    altTitle="box image 1"
                    date={publish_date}
                    contentTitle={title}
                    boxPara={description}
                    link={`/blog/${slug}`}
                  />
                )
              })}
            </div>
          </div> */}

        </div>
      </Wrapper>
    </>
  );
};

export default HomePage;
